import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import DeactivationGroup from "./deactivationGroup";

export default function TabBar({ selected,setSelected }) {
  const [openDeactivation, setOpenDeactivation] = useState();
  const styleSelected = {
    fontSize: "18px",
    fontWeight: "700",
    color: "var(--emr-darkblue)",
    cursor: "pointer",
    transition: "0.2s all",
  };
  const styleNotSelected = {
    fontSize: "18px",
    fontWeight: "500",
    color: "var(--emr-disable)",
    cursor: "pointer",
    transition: "0.2s all",
  };
  return (
    <>
    <DeactivationGroup show={openDeactivation} setShow={setOpenDeactivation} />
      <Box display={"flex"} alignItems="center" gap="40px" mt="10px">
        <Typography
          onClick={() => setSelected(0)}
          sx={selected === 0 ? styleSelected : styleNotSelected}
        >
          {"داشبورد"}
        </Typography>
        <Typography
          onClick={() => setSelected(1)}
          sx={selected === 1 ? styleSelected : styleNotSelected}
        >
          {"تاریخچه اردوها"}
        </Typography>
        <Typography
          onClick={() => setSelected(2)}
          sx={selected === 2 ? styleSelected : styleNotSelected}
        >
          {"جهادگران"}
        </Typography>
        <Typography
          onClick={() => setSelected(3)}
          sx={selected === 3 ? styleSelected : styleNotSelected}
        >
          {"مشخصات"}
        </Typography>
        <Typography
          onClick={() => setOpenDeactivation(!openDeactivation)}
          fontSize="18px"
          sx={
            selected === 4
              ? {
                  color: "#E24B4B",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "0.2s all",
                }
              : {
                  color: "#E24B4B8C",
                  cursor: "pointer",
                  transition: "0.2s all",
                }
          }
        >
          {"غیرفعال سازی"}
        </Typography>
      </Box>
    </>
  );
}
